var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({backgroundColor: _vm.$common.transparent ? _vm.bg_color : '#FFFFFF'})},[_c('Wp_home_all_model',{attrs:{"top-px":_vm.topPx},on:{"getColors":_vm.getColors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }